import { authorize, deleteRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const backendURL = `${AWS_API_URL}/bookings`;

export async function deleteBookingAPI(bookingId) {
  return deleteRequest(`${backendURL}/${bookingId}`, await authorize());
}

